import Immutable from 'immutable';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import ReviewSummary from 'marketplace-ui-reviews/records/ReviewSummary';
const defaults = {
  companyName: '',
  exampleUrl: '',
  featureHeadlines: Immutable.List(),
  installsCount: 0,
  name: '',
  offeringId: 0,
  priceCents: 0,
  reviewSummary: null,
  slug: '',
  thumbnailUrl: ''
};
class ThemeCardResult extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);
    if (json.featureHeadlines) {
      jsonCopy.featureHeadlines = Immutable.List(json.featureHeadlines);
    }
    if (json.reviewSummary) {
      jsonCopy.reviewSummary = new ReviewSummary(json.reviewSummary);
    }
    super(cleanObject(jsonCopy));
  }
}
export default ThemeCardResult;